import React from 'react';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";

const measureValuesObject = `
message MeasureValue {
  string uuid = 1;
  ace.id.Urn activity = 2;
  ace.id.Urn measurement = 3;
  float value = 4;
  uint64 timestamp = 5;
  string subject = 6;
}`

const measureValuesService = `
service MeasureValuesApiService {
  rpc connect(stream gc.ace.v1.api.MeasureValue) 
    returns (MeasureValuesSubmitResponse) {}
  rpc currentMeasureValues(CurrentMeasureValuesRequest) 
    returns (stream gc.ace.v1.api.MeasureValue) {}
  rpc currentMeasureValue(CurrentMeasureValueRequest) 
    returns (gc.ace.v1.api.MeasureValue) {}
}
`

const ApiTemplate = ({objects,services}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <>OBJECTS</>
      <pre>{objects[0]}</pre>
      <>SERVICES</>
      <pre>{services[0]}</pre>
    </Stack>
  )
}

export const ApiPage = ({}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={'API'}
        SubHeader={''}
        Alignment="left"
      />
      <>AlarmsV1</>

      <ApiTemplate objects={[measureValuesObject]} services={[measureValuesService]}/>

      <>CalculatedValuesV1 [beta]</>
      <>CalculationsV1 [beta]</>
    </Stack>
  );
}